import AuthApis from '@/components/Controllers/AuthApis';
import store from '@/store/store';

/**
 * Router hit api to check, if the current token is a valid token, else throw back to login screen
 */
export default async function validateToken({ next, router }) {
  const isvalidToken = await AuthApis.isValidToken();
  if (isvalidToken === false) {
    store.dispatch('SET_USER_DATA_EMPTY', '');
    store.dispatch('snackbar/snackbar', {
      text: 'Session expired, Please login again.',
      timeout: 5000,
      open: true,
    });
    return router.push({ name: 'Login' });
  }
  return next();
}
